import { render, staticRenderFns } from "./DeptManager.vue?vue&type=template&id=6cf44236&scoped=true"
import script from "./DeptManager.vue?vue&type=script&lang=js"
export * from "./DeptManager.vue?vue&type=script&lang=js"
import style0 from "./DeptManager.vue?vue&type=style&index=0&id=6cf44236&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf44236",
  null
  
)

export default component.exports